import { render, staticRenderFns } from "./AvatarForm.vue?vue&type=template&id=beb727c4&"
import script from "./AvatarForm.vue?vue&type=script&lang=js&"
export * from "./AvatarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports